import React, { ChangeEventHandler, useId } from 'react';

type InputProps = {
  className: string;
  label: string;
  value: any;
  onChange?: ChangeEventHandler<HTMLInputElement> | undefined;
  disabled?: boolean;
};

const ModalInput = (props: InputProps) => {
  const id = useId();

  return (
    <div className={props.className}>
      <label htmlFor={id} className="mb-2 block text-xs font-medium">
        {props.label}
      </label>
      <input
        type="text"
        id={id}
        className="w-full rounded-md border p-2 text-sm bg-swopa-white border-swopa-grey-3 enabled:hover:border-swopa-secondary-light-blue focus:border-swopa-secondary-light-blue focus:outline-none disabled:bg-gray-100"
        disabled={!props.onChange || props.disabled}
        onChange={props.onChange}
        value={props.value}
      />
    </div>
  );
};

export default ModalInput;
